import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

const DynamicTable = ({ data, columns, keyField }) => {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing { from } to { to } of { size } Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to first and last page button
    hidePageListOnlyOnePage: true, // Hide the page list if only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: "5", value: 5
    }, {
      text: "10", value: 10
    }, {
      text: "All", value: data.length
    }] // A numeric array is also available. the purpose of above example is to show how to use more complex one
  };

  return (
    <BootstrapTable
      keyField={keyField}
      data={data}
      columns={columns}
      pagination={paginationFactory(options)}
      noDataIndication="No data to display"
    />
  );
};

export default DynamicTable; 